import React from 'react';
import './CreateCustomReportPopup.css';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import toasts from '../../utils/toasts';
import models from '../../model/models';
import Button from "../../components/button/Button";

export default class CreateCustomReportPopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.state = {};
    this.myRefs  = {};
	}

  componentDidMount = () => {
    this.focus();
  };

  focus(){
    this.myRefs.name.focus()
  }

	_save = async () => {
		if (!this.isValid()) return this._saveState();
		let value = this.getValue();
		value.fields = this.props.fields;
		let success = await models.report.save(value);
		if (!success) toasts.show('Something went wrong');
		this.props.onClose({created: true});
	};
	_saveState = () => {
		let value = this.getValue();
		this.setState(value);
	};
  cycleTab = (e) => {
    e.preventDefault();
    this.focus()
  }

	render() {
		return (
			<Popup {...this.props} className="g-create-custom-report-popup" role="alertdialog">
				<Card>
					<Label larger black>
						Custom Report
					</Label>
					<Label>Name (required)</Label>
					<Input required value={this.state.name} ref={(ref) => (this.myRefs.name = ref)} />
					<Label>Description (required)</Label>
					<Input required value={this.state.description} ref={(ref) => (this.myRefs.description = ref)} />
          <div className={'flex-row'}>
					<PrimaryButton onClick={this._save}>Save</PrimaryButton>
					<Button className={'cancel'} bg={'red'} color={'white'} onClick={this.props.onClose} onKeyDown={this.cycleTab}>Cancel</Button>
          </div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/createCustomReportPopup/CreateCustomReportPopup.jsx